// GCCV2KyuseiResult.tsx
import React from "react";
import GCCV2TabDashboard from "./GCCV2TabDashboard";
import { getGCCV2StrictLanguageInstruction } from "../../../utils/GCC/astriaGCCV2Language";

const PROMPT = {
  en: (dob: string) =>
    `Give me my GCC Kyusei reading — my behavior pattern, inner rhythm, outer rhythm, and growth pattern.\nDate of Birth: ${dob}\n${getGCCV2StrictLanguageInstruction("en")}`,
  ar: (dob: string) =>
    `أعطني قراءة "النمط" الخاصة بي — نمط سلوكي، وإيقاعي الداخلي، وإيقاعي الخارجي، ونمط نموي.\nتاريخ الميلاد: ${dob}\n${getGCCV2StrictLanguageInstruction("ar")}`,
};

const GCCV2KyuseiResult: React.FC = () => (
  <GCCV2TabDashboard
    tab="kyusei"
    tabKey="kyusei"
    subCategoryMatch="kyusei"
    buildPrompt={(dob, language) => PROMPT[language](dob)}
    title={{ en: "Your Pattern", ar: "نمطك" }}
    subtitle={{
      en: "Behavior pattern, inner rhythm, outer rhythm, and growth pattern.",
      ar: "نمط سلوكك، وإيقاعك الداخلي والخارجي، ونمط نموك.",
    }}
  />
);

export default GCCV2KyuseiResult;
